import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'`,
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#232e4c', // from HD logo
    },
    secondary: {
      main: '#4a8fcd', // from HD logo
    },
    success: {
      main: '#2e7d32', // Green for success messages
    },
    error: {
      main: '#d32f2f', // Red for error messages
    },
    warning: {
      main: '#ed6c02', // Orange for warnings
    },
    info: {
      main: '#0288d1', // Light blue for informational messages
    },
    background: {
      default: '#ffffff', // Clean white background
      paper: '#ffffff',
    },
    divider: '#e0e0e0', // Light gray dividers
    text: {
      primary: '#212121', // Dark gray text for readability
      secondary: '#757575', // Medium gray for secondary text
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        outlined: {
          border: '1px solid #e0e0e0', // Subtle border matching divider color
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Preserve case in button text
          boxShadow: 'none',              // 🔧 No elevation
          '&:hover': {
            boxShadow: 'none',            // 🔧 No hover elevation either
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      }
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      }
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },

    // ✅ ADD THESE TWO OVERRIDES:
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e0e0e0', // Matches your theme.divider
          padding: '8px 16px', // Compact padding (adjust as needed)
          maxWidth: 250,             // adjust globally as needed
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
    }
  },
});

export default theme;
